export default __webpack_public_path__ + "static/media/pngjoy.com_mongodb-mongodb-icon-png-download_7091544.f22fc8cb.png";